import { render, staticRenderFns } from "./renew_academic.vue?vue&type=template&id=5ac09947"
import script from "./renew_academic.vue?vue&type=script&lang=js"
export * from "./renew_academic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports